module.exports = __webpack_public_path__ + "static/media/prison.07425371.svg";